import { AsyncResult, ApiAction } from '../index';
import api from '../redux-api';

type JobStatus = {
  jobId: string;
  isFinished: boolean;
  isFailed?: boolean;
};

// Actions
const GET_JOB_STATUS: ApiAction = {
  type: 'connect/jobs/get-status',
  endpoint: 'jobs/:id/',
};

// Action Creators
export const getJobStatus =
  (id: string): AsyncResult<JobStatus> =>
  (dispatch, getState) =>
    api.get(GET_JOB_STATUS, { id });

export const waitJob =
  (id: string, timeout: number = 10000): AsyncResult<void> =>
  (dispatch, getState) => {
    const retryDelay = 1000; // Check job every second.
    const start = new Date().getTime();

    return new Promise((resolve, reject) => {
      const interval = setInterval(() => {
        dispatch(getJobStatus(id)).then((status: JobStatus) => {
          if (status.isFinished) {
            clearInterval(interval);

            if (status.isFailed) {
              return reject({ errorKey: 'JOB_ERROR' });
            }

            return resolve();
          }

          if (new Date().getTime() - start > timeout) {
            clearInterval(interval);
            return reject({ errorKey: 'JOB_TIMED_OUT' });
          }
        });
      }, retryDelay);
    });
  };
